export default "__VITE_ASSET__0bc4d756__"